import { mag, normalize, sub } from "@thi.ng/vectors";
import { intersectRayPolylineAll } from "./ray-poly";
export const intersectLinePolylineAll = (a, b, pts, closed = false) => {
    const dir = sub([], b, a);
    const maxD = mag(dir);
    return intersectRayPolylineAll(a, normalize(null, dir), pts, closed, 0, maxD);
};
